export const warrentydata = [
    {
        "id": 1,
        "name": "Express Warranty",
        "description": "Repairs or a replacement for a faulty product within a\n                                                specified time period after it was purchased.",
        "duration": "3 Months",
        "status": "Active",
        "Action": ""
    },
    {
        "id": 2,
        "name": "Special warranty",
        "description": "Seller of the property(grantor) warrants only against\n                                                anything that occurred during their physical ownership.",
        "duration": "6 Months",
        "status": "Active",
        "Action": ""
    },
    {
        "id": 3,
        "name": "Implied Warranty",
        "description": "Assurances that a product is fit for the purpose that it is\n                                                intended and that it is merchantable.",
        "duration": "1 Year",
        "status": "Active",
        "Action": ""
    }
]